<template>
  <div>
    <v-layout row wrap justify-center align-center text-xs-center pb-5 mt-5 class="cont_page">
      <v-flex xs12 sm9 md7 mt-4 class="text-xs-left">
        <h1 class="animated bounceIn dura-1">
          <span class="icon-titulo"></span>¿Quién puede hacer monitoreo de atmósferas?
        </h1>
        <!-- <h2 class="animated bounceIn dura-2">Personas autorizadas</h2> -->
      </v-flex>
      <v-flex xs12 sm9 md7 mt-3 class="text-xs-left">
        <!-- items imagen con texto en movil -->
        <v-flex xs12 sm9 md7 mt-4 class="text-xs-left" v-show="$vuetify.breakpoint.xs">
        </v-flex>
        <span><strong> Personas Autorizadas </strong></span>
        <v-layout text-xs-center>
          <v-flex md12 xs12>
            <img
              class="animated flipInY dura-1"
              :src="require('../../assets/unidad2/pantalla-1-4.png')"
              alt=""
            />
          </v-flex>
        </v-layout>
        <v-flex xs12>
          <p>
            Ahora, vamos a conocer las responsabilidades y los requisitos para
            que una persona sea autorizada para realizar la prueba de gas y la
            calibración del equipo.
          </p>
        </v-flex>
        <v-flex md7>
          <span>
            <strong
              >Autorización para realizar el monitoreo de atmósferas para trabajador directo.
            </strong>
          </span>
        </v-flex>
        <p>
          Para autorizar por primera vez a un trabajador directo de Ecopetrol S.
          A. para la realización de pruebas de gases, se deben cumplir los
          siguientes requisitos mínimos:
        </p>
        <p class="instruccion">
          Haz clic en los puntos para revisar la información
        </p>
        <scrolldown-app></scrolldown-app>
      </v-flex>
      <!-- slide de imagenes -->
      <v-flex xs12 sm7 md7 class="animated fadeInUp text-xs-center">
        <v-card color="transparent" flat tile>
          <v-window v-model="onboarding">
            <v-window-item v-for="n in length" :key="`card-${n}`">
              <v-card class="cont_text-slider" color="transparent" flat>
                <v-flex class="flip-item">
                  <img
                    class="animated flipInY dura-1"
                    :src="
                      require('../../assets/unidad2/pantalla1-' + n + '.png')
                    "
                    alt=""
                  />
                </v-flex>
                <v-flex>
                  <p class="caja_texto" v-html="texto[onboarding]"></p>
                </v-flex>
              </v-card>
            </v-window-item>
          </v-window>
          <v-card-actions class="cont_buttons-slider">
            <v-item-group
              light
              v-model="onboarding"
              class="text-center"
              mandatory
            >
              <v-item
                v-for="n in length"
                :key="`btn-${n}`"
                v-slot:default="{ active, toggle }"
              >
                <v-btn
                  :color="vistosSlide[n - 1] ? '#ff9955ff' : '#28f7d1ff'"
                  small
                  class="item-button"
                  :input-value="active"
                  icon
                  @click="toggle"
                >
                  <v-icon>mdi-record</v-icon>
                </v-btn>
              </v-item>
            </v-item-group>
          </v-card-actions>
        </v-card>
        <v-layout align-center class="contenido2">
          <v-flex md4 xs12 class="flip-item">
            <img
              :src="require('../../assets/unidad2/pantalla-1-8.png')"
              alt=""
            />
          </v-flex>
          <v-flex ml-2>
            <p>
              La persona que cumpla con los requisitos antes mencionados será
              autorizada por el área encargada de la Prevención y Control de
              Emergencia o por la asignada oficialmente en cada Gerencia o cargo
              similar.
            </p>         
          </v-flex>    
        </v-layout>  
      </v-flex> 
      <v-flex xs12 sm9 md7 mt-3 class="text-xs-left"> 
        <span>  
          <strong>Vigencia de la autorización </strong>
        </span>
        <p>         
          La autorización debe ser renovada si cambia el equipo con el que fue
          entrenado para realizar la prueba de gas.
        </p>
        <p>
          Para revalidar la autorización, debe participar y aprobar el curso
          mínimo de 3 horas de duración en conceptos teóricos y prácticos en el
          manejo del equipo portátil detector de gases.
        </p>
        <p class="instruccion">
          Haz clic para ver los requisitos para el personal aliado.
        </p>
      </v-flex>
      <v-flex xs12 sm9 md7 mt-3 class="hvr">
        <img
          class="hvr-scale"
          :src="require('../../assets/unidad2/pantalla-1-9.png')"
          alt=""
          @click="infoAutorizacion()"
        />
      </v-flex>
      <v-flex xs12 sm9 md7 mt-3 class="text-xs-left">
        <span>
          <strong
            >Autorización para calibración de equipos de medición de gases para
            trabajador directo de Ecopetrol S. A.
          </strong>
        </span>

        <v-layout align-center text-xs-center mt-2>
          <v-flex md12>
            <img
              class="animated flipInY dura-1"
              :src="require('../../assets/unidad2/pantalla-1-10.png')"
              alt=""
            />
          </v-flex>
        </v-layout>
        <v-flex ml-2>
          <p>
            Para autorizar a un trabajador directo de Ecopetrol S. A. por
            primera vez en la calibración de equipos de medición de gases, deben
            cumplirse los siguientes requisitos mínimos:
          </p>
        </v-flex>

        <v-layout
          class="flip-item contenido2"
          v-for="n in 2"
          :key="`card-${n}`"
          align-center
        >
          <v-flex md2>
            <img
              class="animated flipInY dura-1"
              :src="require('../../assets/unidad2/Icono1-' + n + '.png')"
              alt=""
            />
          </v-flex>
          <v-flex md10 xs12>
            <p class="text-xs-left" v-html="items2[n - 1]"></p>
          </v-flex>
        </v-layout>
      </v-flex>
      <v-flex xs12 sm9 md7 mt-3 class="text-xs-left">
        <span><strong>Vigencia de la certificación </strong></span>
        <p>
          Si se presenta algún cambio de tecnología en los equipos detectores de
          gases portátiles, el personal que se encuentre autorizado debe
          participar en una capacitación de actualización y se emitirá una nueva
          certificación.
        </p>
        <p class="instruccion">
          Haz clic para ver los requisitos para el personal aliado.
        </p>
        <v-flex xs12 sm9 md12 mt-3 class="hvr" text-xs-center>
          <img
            class="hvr-scale"
            :src="require('../../assets/unidad2/pantalla-1-9.png')"
            alt=""
            @click="infoAutorizacion2()"
          />
        </v-flex>
        <span
          ><strong
            >Responsabilidades de la persona autorizada (directa o aliada) que
            realiza la prueba de gases
          </strong></span
        >
        <ul class="items">
          <li>
            Realizar y asegurar que la prueba de gases sea confiable antes de
            iniciar un trabajo o durante su desarrollo.
          </li>
          <li>
            Garantizar que el equipo es confiable mediante la calibración y
            verificación periódica del mismo, además, verificar la correcta y
            completa carga de la batería.
          </li>
          <li>
            Seguir las recomendaciones establecidas en el manual del fabricante
            del equipo.
          </li>
          <li>
            Atender y dar cumplimiento al programa de capacitación y
            entrenamiento para la actualización de la autorización para realizar
            la prueba de gases
          </li>
        </ul>
        <p>
          <strong>Recuerda:</strong> consultar y seguir las recomendaciones
          establecidas en el manual del fabricante del equipo
        </p>
      </v-flex>
    </v-layout>
    <!-- modalAutorizacion -->
    <modal-app v-model="modalAutorizacion" :fullscreen="false">
      <template slot="modaltittle">
        <h1 class="modal-icon-title"></h1>
      </template>
      <template slot="modalcontent">
        <v-flex>
          <span
            ><strong
              >Autorización para realizar prueba de gases para personal
              aliado.</strong
            >
          </span>
        </v-flex>
        <v-flex mt-2>
          <p>
            Para que un trabajador aliado sea autorizado en la realización de la
            prueba de gases, debe cumplir los siguientes requisitos mínimos:
          </p>
        </v-flex>
        <v-layout row wrap justify-center>
          <v-flex class="text-xs-left">
            <ol>
              <li>
                Comunicación de la empresa del aliado donde relacionen las
                personas (nombre y cédula) que van a hacer la prueba de gases y
                el equipo que van a utilizar.
              </li>
              <li>
                Comunicación del fabricante o proveedor del equipo donde indique
                la aprobación del curso, de mínimo de 3 horas de duración, sobre
                el manejo del detector de gases, especificando la empresa y el
                equipo de prueba de gases en el que fue entrenado.
              </li>
              <li>
                Acompañamiento de un tutor avalado para la realización de prueba
                de gas vigente, durante la realización de 5 pruebas de gases.
                Este acompañamiento debe quedar documentado en el formato
                vigente especificando en la casilla de alcance del trabajo:
                Prueba de gases.
              </li>
              <li>
                Certificación de experiencia en el cargo mínimo de 6 meses.
              </li>
              <li>
                Divulgación registrada de este instructivo por parte del área encargada de la prevención y control de emergencia o por la asignada oficialmente en cada gerencia o nivel equivalente.
                <br />
                <br />
                Para el personal aliado que cumpla con los requisitos antes
                mencionados, será autorizada por el área encargada de la
                prevención y control de emergencia o por la asignada
                oficialmente en cada gerencia o nivel equivalente, especificando
                la empresa y el equipo de prueba de gases en el que fue
                entrenado.
              </li>
            </ol>
          </v-flex>
        </v-layout>
      </template>
    </modal-app>
    <!-- modalAutorizacion -->
    <modal-app v-model="modalAliado" :fullscreen="false">
      <template slot="modaltittle">
        <h1 class="modal-icon-title"></h1>
      </template>
      <template slot="modalcontent">
        <v-flex>
          <span
            ><strong
              >Autorización para calibración de equipos de medición de gases
              para personal aliado
            </strong>
          </span>
        </v-flex>
        <v-flex mt-2>
          <p>
            Para los aliados se realizará a través del fabricante o proveedor de
            dichos equipos o por una persona autorizada por el fabricante o
            proveedor para realizar la calibración.
          </p>
        </v-flex>
        <v-layout row wrap justify-center>
          <v-flex class="text-xs-left">
            <span><strong>Vigencia de la autorización </strong> </span>
            <p>
              La constancia emitida por el proveedor o fabricante de la persona
              autorizada para realizar la calibración debe indicar: nombre,
              número de cédula de ciudadanía, empresa, marca y modelo del equipo
              en el que fue entrenado.
            </p>
            <p>
              Si se presenta algún cambio de empresa o de equipo en el que fue
              entrenado, se debe renovar la constancia.
            </p>
          </v-flex>
        </v-layout>
      </template>
    </modal-app>
  </div>
</template>
<script>
import nextConditions from "../../js/mixins/nextConditions";
export default {
  mixins: [nextConditions],
  data() {
    return {
      length: 3,
      modalAutorizacion: false,
      modalAliado: false,
      onboarding: 0,
      vistosSlide: Array(3).fill(false),
      dialogos: [" "],
      texto: [
        "<strong>1.</strong> Experiencia de 6 meses en el cargo. Esta experiencia podrá ser certificada por la Vicepresidencia de Talento Humano (VTH) en donde se establezca la antigüedad del personal o la certificación que se emite por autoservicio, indicando el cargo y la antigüedad.",
        "<strong>2.</strong> Participación y aprobación del curso mínimo de 3 horas de duración en conceptos teóricos y prácticos en el manejo del equipo portátil detector de gases disponibles en las áreas.",
        "<strong>3.</strong> Acompañamiento de un tutor avalado para la realización de prueba de gas vigente, durante la realización de 5 pruebas de gases. Este acompañamiento debe quedar documentado en el formato de reporte de acompañamiento vigente, especificando el alcance del trabajo: prueba de gases.",
      ],
      items: [
        "Trabajos en frío, en caliente o eléctricos, donde pueda haber presencia de gases o vapores.",
        "Emergencias por materiales peligrosos HAZMAT.",
        "Entrada a espacios confinados (dentro y fuera del espacio).",
      ],
      items2: [
        "<strong>1.</strong> Participar y aprobar el curso realizado por el proveedor o fabricante (mínimo de 3 horas de duración) en conceptos teóricos y prácticos en calibración de equipos de medición de gases.  ",
        "<strong>2.</strong> Acompañamiento de un tutor autorizado, durante la realización de 5 calibraciones de equipos detectores de gases portátiles de la misma marca y modelo. Para más información se debe revisar el documento vigente.  ",
      ],
    };
  },
  created() {
    this.$set(this.vistosSlide, 0, true);
  },
  watch: {
    onboarding(val) {
      this.$set(this.vistosSlide, val, true);
    },
  },
  methods: {
    infoAutorizacion() {
      this.modalAutorizacion = true;
    },
    infoAutorizacion2() {
      this.modalAliado = true;
      this.$store.commit("nextShow", true);
    },
  },
};
</script>
<style lang="scss" scoped>
@import "../../sass/globals";
.icon-titulo {
  content: url("../../assets/imagenes_compartidas/icon-titulo.png");
  width: 0.7em;
}
hr {
  height: 2px;
  background-color: $color-complement-one;
  border: none;
  margin-bottom: 1em;
}
.caja_texto {
  background: #ffff;
  padding: 5px 5px 5px 5px;
}
.cont_buttons-slider {
  justify-content: center;
  .item-button {
    width: 15px;
    height: 15px;
  }
}
.flip-item {
  position: relative;
  width: 100%;
  height: auto;
  padding: 10px;
  p {
    text-align: center;
  }
  .pb {
    color: $color-secondary;
    font-family: FontBase-Bold;
  }
  @media screen and (max-width: 330px) {
    img {
      width: 150px;
    }
  }
}
.items {
  font-size: 13.6px;
}
.container-module {
  @media screen and (max-width: 500px) {
    text-align: center;
    img {
      width: 25%;
    }
    .modulo-name {
      width: 100%;
      padding-left: 0px;
    }
  }
}
@media screen and (max-width: 500px) {
  .contenido2 {
    display: flex;
    flex-direction: column;
    align-items: center;
  }
}
</style>

